// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FilePdfIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from file-pdf.svg
 */
export default function FilePdfIcon(props: FilePdfIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FilePdfIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M12.333 0a.5.5 0 0 1 .352.144l2.167 2.143a.5.5 0 0 1 .148.356V15.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zM11 1H2v14h12V4h-2.5a.5.5 0 0 1-.5-.5zM8.538 4.507C8.492 3.274 7.72 3 7.449 3c-.408 0-1.089.32-1.089 1.279 0 .821.091 1.552.68 2.511l-.15.394-.182.445q-.098.234-.212.485c-.108.273-.233.53-.355.78q-.123.252-.234.499c-.94.325-1.518.688-1.895.99l-.187.159-.08.073-.197.193c-.686.73-.583 1.281-.456 1.555l.048.09.098.126c.156.187.41.421.809.421a1 1 0 0 0 .21-.028l.243-.063.111-.051.071-.042.083-.057.093-.075.106-.098.058-.059.125-.138.138-.169.152-.203.082-.116.173-.262.093-.147.196-.328.104-.182.22-.403q.114-.214.237-.456c.363-.137.77-.228 1.225-.32a22 22 0 0 1 1.587-.228l.178.185.32.322c.694.682 1.05.887 1.498 1 .182.091.363.091.5.091.68 0 .997-.41 1.088-.639.09-.274.181-.959-.5-1.37-.498-.274-1.315-.456-2.358-.456h-.363a3 3 0 0 1-.103-.11l-.222-.256-.129-.137-.195-.216-.348-.4a12 12 0 0 1-.681-.89c.332-.838.445-1.355.482-1.77l.013-.218zM5.226 10.67c-.413.224-.67.425-.85.589l-.193.188c-.212.213-.259.37-.27.473l-.002.074.09.046h-.045l.029.023c.017.011.04.023.062.023 0 .045.045.045.09 0l.023-.007.039-.022.057-.044.075-.07.096-.103.116-.139.137-.181.076-.109.17-.254.194-.31q.052-.084.106-.177m5.642-.831-.244-.219c.314.018.568.062.766.113l.212.063.087.03.136.057.115.057.065.06c.05.051.101.122.07.214 0 .045-.09.09-.271.09a.2.2 0 0 1-.042-.006l-.118-.032-.067-.007c-.19-.038-.347-.107-.709-.42M7.676 7.703v.046l-.243.571a4 4 0 0 0-.075.205l-.13.268a2 2 0 0 0-.097.234h.046l-.09.046.249-.063c.079-.017.158-.028.25-.028l.263-.042.495-.1.239-.04a15 15 0 0 1-.398-.472L7.84 7.9zm-.363-3.379q0-.342.136-.41c.09.045.227.228.227.639v.08l-.007.183a3.3 3.3 0 0 1-.175.832c-.181-.548-.226-.913-.181-1.324"
        />
      </g>
    </svg>
  );
}
